module.exports = __webpack_public_path__ + "img/BE0821165475.1d4d7ab5.png";